export interface ReadingPlanEntry {
  day: number;
  date: string;
  readings: string[];
}

class ReadingPlanService {
  private planData: ReadingPlanEntry[] | null = null;

  async loadPlan(): Promise<ReadingPlanEntry[]> {
    if (this.planData) {
      return this.planData;
    }

    try {
      const response = await fetch('/2026.json');
      if (!response.ok) {
        throw new Error('Failed to load reading plan');
      }
      this.planData = await response.json();
      return this.planData!;
    } catch (error) {
      console.error('Error loading reading plan:', error);
      throw error;
    }
  }

  async getReadingsForDay(dayOfYear: number): Promise<ReadingPlanEntry | null> {
    const plan = await this.loadPlan();
    const entry = plan.find((entry) => entry.day === dayOfYear);
    return entry || null;
  }

  async getDayOfYear(date: Date): Promise<number> {
    const start = new Date(date.getFullYear(), 0, 0);
    const diff = date.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
  }

  async getDateFromDayOfYear(
    dayOfYear: number,
    year: number = 2026
  ): Promise<Date> {
    const start = new Date(year, 0, 0);
    const targetDate = new Date(
      start.getTime() + dayOfYear * 24 * 60 * 60 * 1000
    );
    return targetDate;
  }
}

export const readingPlanService = new ReadingPlanService();
